<template>
  <template v-if="theme == 'blackdiamond'">
    <BlackDiamondHome :searchQuery="searchQuery"></BlackDiamondHome>
  </template>
  <template v-if="theme == 'crispazure'">
    <CrispAzureHome :articleTipText="articleTipText" :articleTipHeading="articleTipHeading"
      :articleTipsstatus="articleTipsstatus" :searchQuery="searchQuery"></CrispAzureHome>
  </template>
  <template v-if="theme == 'bluesky'">
    <BlueSkyHome :articleTipText="articleTipText" :articleTipHeading="articleTipHeading"
      :articleTipsstatus="articleTipsstatus" :searchQuery="searchQuery"></BlueSkyHome>
  </template>
  <template v-if="theme == 'astrofusion'">
    <AstroFusionHome :articleTipText="articleTipText" :articleTipHeading="articleTipHeading"
      :articleTipsstatus="articleTipsstatus" @searchQuery="$emit('searchQuery', $event)" :searchQuery="searchQuery">
    </AstroFusionHome>
  </template>
</template>
<script>
import BlackDiamondHome from './blackdiamond/Home.vue';
import CrispAzureHome from './crispazure/Home.vue';
import BlueSkyHome from './bluesky/Home.vue';
import AstroFusionHome from './astrofusion/Home.vue';

export default {
  name: 'HubHome',
  components: {
    BlackDiamondHome,
    CrispAzureHome,
    BlueSkyHome,
    AstroFusionHome,
  },
  props: ['searchQuery', 'theme', 'articleTipHeading', 'articleTipText', 'articleTipsstatus', 'subscription_plan'],
  emits: ['searchQuery'],
  data() {
    return {};
  },
  mounted() {
    // window.addEventListener('beforeunload', () => {
    //   const iframe = document.getElementById('widget-iframe');
    //   if (iframe && iframe.contentWindow) {
    //     iframe.contentWindow.postMessage({ message: 'widgetUnloaded' }, '*');
    //   }
    // }); 
  },
};
</script>
